import Tophead from './Components/Nav/Tophead';
import './App.css';
import Homesplash from './Components/Main/Homesplash';
import Projects from './Components/Gallery/Projects';
import Timeline from './Components/Timeline/Timeline';
import Profile from './Components/Aboutme/Profile';
import Footerbar from './Components/Nav/Footerbar';
import curcircle from './curcircle';

function App() {
  return (
    <>
    
    <div className='background'>
      <Tophead/>
      <Homesplash/>
      <Projects/>
      <Timeline/>
      <Profile/>
      <Footerbar/>
    </div>
    
    
    </>
  );
}

export default App;